(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('classicalActivityEditor', classicalActivityEditor);

    function classicalActivityEditor() {
        return {
            templateUrl: '/app/directives/activities/classical-activity-editor.tpl.html',
            scope: {
                item: '=',
                hideExaminers: '=',
                catalogItems: '=',
                editMode: '=',
                classicalActivitySwitchEnabled: '='
            },
            controller: ClassicalActivityEditorController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function ClassicalActivityEditorController() {
        var vm = this;

        vm.items = _.where(vm.catalogItems, { targetType: 2 });
        vm.selected = (vm.isNamedCourse) ? vm.item : _.findWhere(vm.items, { targetId: vm.item.targetId });
        vm.isNamedCourse = vm.item.name ? true : false;
        
        vm.change = change;
        vm.toggleCourseType = toggleCourseType;

        function change() {
            vm.item.targetId = vm.selected.targetId;
        }
        
        function toggleCourseType() {
            vm.isNamedCourse = !vm.isNamedCourse;

            if (vm.isNamedCourse) {
                delete vm.selected;
                delete vm.item.targetId;
            } else {
                delete vm.item.name;
                delete vm.item.examiners;
            }
        }
    }

})();